import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import store from "../store/store"
import 'element-ui/lib/theme-chalk/index.css';
import VueWechatTitle from 'vue-wechat-title'
import './css/element-red.scss'
import './css/global.scss'
import './utils/request'

const shortid = require('js-shortid');

Vue.use(ElementUI);
Vue.use(VueWechatTitle);
// Vue.use(Vuex);
Vue.config.productionTip = false

Vue.prototype.uuid = () => {
  return shortid.gen();
}
// const snap = require(`imports-loader?this=>window,fix=>module.exports=0!snapsvg/dist/snap.svg.js`);
// //console.log(snap)
var vue = new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')

export default vue